import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject, defer, Observable } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { Meta, Title } from '@angular/platform-browser';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class CountrycurrencypageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService,
    private upmeta: Meta,
    private title: Title
  ) {}
  currenciesData: any;
  countryCurrencyData: any;

  private heroSubject$ = new BehaviorSubject<any>(null);
  public hero$ = this.heroSubject$.asObservable();
  private coverageSubject$ = new BehaviorSubject<any>(null);
  public coverage$ = this.coverageSubject$.asObservable();
  private featuresSubject$ = new BehaviorSubject<any>(null);
  public features$ = this.featuresSubject$.asObservable();
  private contentPanelSubject$ = new BehaviorSubject<any>(null);
  public contentPanel$ = this.contentPanelSubject$.asObservable();
  private formSubject$ = new BehaviorSubject<any>(null);
  public form$ = this.formSubject$.asObservable();
  private faqSubject$ = new BehaviorSubject<any>(null);
  public faq$ = this.faqSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();
  private pricingSubject$ = new BehaviorSubject<any>(null);
  public pricing$ = this.pricingSubject$.asObservable();

  getCountryCurrencyPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.countryCurrencyData = mod.filter(
          x => x?.fields?.['id'] == PageId.coverageCurrencyKenyanShillings
        );
        const heroData = this.countryCurrencyData[0]?.fields;
        if (heroData) {
          this.heroSubject$.next(heroData);
        }
        const featuresData =
          this.countryCurrencyData[0]?.fields?.features[0].fields;
        if (featuresData) {
          this.featuresSubject$.next(featuresData);
        }
        const contentPanelData =
          this.countryCurrencyData[0]?.fields?.contentPanel[0].fields;
        if (contentPanelData) {
          this.contentPanelSubject$.next(contentPanelData);
        }
        const formData = this.countryCurrencyData[0]?.fields?.forms.fields;
        if (formData) {
          this.formSubject$.next(formData);
        }
        const coverageData =
          this.countryCurrencyData[0]?.fields?.coverage.fields;
        if (coverageData) {
          this.coverageSubject$.next(coverageData);
        }
        const faqsData = this.countryCurrencyData[0]?.fields?.faq?.fields;
        if (faqsData) {
          this.faqSubject$.next(faqsData);
        }
        // const getStarted = this.countryCurrencyData[0]?.fields?.getStartedContentPanel.fields;
        // if (getStarted) {
        //   this.getStartedSubject$.next(getStarted);
        // }
      });
  }
  getCurrenciesPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
          limit: 300,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];

        this.currenciesData = mod.filter(
          x => x?.fields['id'] == PageId.coverageCurrenciesAlt
        );
        const getStarted =
          this.currenciesData[0].fields.getStartedContentPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
  getCurrencyAllData(): Promise<any[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
        })
      )
      .then(res => res.items)
      .catch(error => {
        console.error('Error fetching currency data:', error);
        return [];
      });
  }
  getCountryCurrencyDetailByID(id: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.coveragePage,
          'fields.id': id,
        })
      )
      .then(res => res.items)
      .catch(error => {
        console.error(`Error fetching currency detail for:`, error);
        return [];
      });
  }

  getCountryCurrencyDetailByIDData(id: string) {
    this.getCountryCurrencyDetailByID(id).then(data => {
      if (data.length > 0) {
        this.countryCurrencyData = data;;
        const heroData = this.countryCurrencyData?.[0]?.fields;
        if (heroData) {
          this.heroSubject$.next(heroData);
        }
        const featuresData =
          this.countryCurrencyData?.[0]?.fields?.features?.[0]?.fields;
        if (featuresData) {
          this.featuresSubject$.next(featuresData);
        }
        const contentPanelData =
          this.countryCurrencyData?.[0]?.fields?.contentPanel?.[0]?.fields;
        if (contentPanelData) {
          this.contentPanelSubject$.next(contentPanelData);
        }
        const formData = this.countryCurrencyData?.[0]?.fields?.forms?.fields;
        if (formData) {
          this.formSubject$.next(formData);
        }
        const coverageData =
          this.countryCurrencyData?.[0]?.fields?.coverage?.fields;
        if (coverageData) {
          this.coverageSubject$.next(coverageData);
        }
        const faqsData = this.countryCurrencyData?.[0]?.fields?.faq?.fields;
        if (faqsData) {
          this.faqSubject$.next(faqsData);
        }
        const getStarted =
          this.countryCurrencyData?.[0]?.fields?.getStartedContentPanel?.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
        const pricing = this.countryCurrencyData?.[0]?.fields;
        if (pricing) {
          this.pricingSubject$.next(pricing);
        }

        const seoData =
          this.countryCurrencyData?.[0]?.fields?.seoMetadataReference?.fields;
        if (seoData) {
          this.meta.updateMeta(seoData);
        }
      }
    });
  }
}
